import React from "react";
import PropTypes from "prop-types";
import styles from "./LoadingDots.scss";

export function LoadingDots({ isLoading }) {
  return (
    <>
      {isLoading && (
        <div className={styles.loadingDots}>
          <span className={styles.loadingDotsDot}></span>
          <span className={styles.loadingDotsDot}></span>
          <span className={styles.loadingDotsDot}></span>
          <span className={styles.loadingDotsDot}></span>
        </div>
      )}
    </>
  );
}

LoadingDots.propTypes = {
  isLoading: PropTypes.bool
};
